import $ from "jquery";

const FAVORITE_ICON_OUTLINE_SRC = "/img/icons/favorite-like.svg";

const FAVORITE_ICON_FILLED = `
  <svg class="contest-favorite-btn__icon" width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M9.25327 1.74386C10.1428 0.852402 11.3494 0.351562 12.6075 0.351562C13.8657 0.351562 15.0724 0.852443 15.9618 1.74395C16.8517 2.63502 17.3516 3.84377 17.3516 5.10417C17.3516 6.36461 16.8516 7.57339 15.9617 8.46447L9.25377 15.1846C9.03152 15.4072 8.67117 15.4072 8.44892 15.1846L1.74094 8.46447C-0.111562 6.60863 -0.111562 3.5997 1.74094 1.74386C3.59343 -0.111993 6.59692 -0.111993 8.44942 1.74386L8.85135 2.14651L9.25327 1.74386Z" fill="currentColor"/>
  </svg>
`;

const FAVORITE_ICON_OUTLINE = `
  <img class="contest-favorite-btn__icon" src="${FAVORITE_ICON_OUTLINE_SRC}" width="18" height="16" alt="">
`;

const TOAST_DURATION_MS = 2500;
const toastTimers = new WeakMap();

const getConfig = () => {
  const $root = $("[data-contest-favorites-config]");
  if (!$root.length) {
    return {
      favoritesPageUrl: "/cabinet/favorite-contests",
    };
  }

  return {
    favoritesPageUrl: $root.data("favorites-page-url") || "/cabinet/favorite-contests",
  };
};

const getFavoriteHint = ($btn, isFavorite) => {
  const hintAdd = $btn.data("hint-add") || "Добавить конкурс в избранное";
  const hintRemove = $btn.data("hint-remove") || "Убрать конкурс из избранного";

  return isFavorite ? hintRemove : hintAdd;
};

const clearToastTimer = (el) => {
  const timerId = toastTimers.get(el);
  if (timerId) {
    window.clearTimeout(timerId);
    toastTimers.delete(el);
  }
};

const restoreHoverHint = ($btn) => {
  const $hint = $btn.find(".contest-favorite-btn__hint");
  if (!$hint.length) {
    return;
  }

  $btn.removeClass("contest-favorite-btn--toast");
  $hint.text(getFavoriteHint($btn, $btn.hasClass("is-favorite")));
};

const updateFavoriteButtons = (contestId, isFavorite) => {
  $(`.js-contest-favorite[data-contest-id="${contestId}"]`).each(function () {
    const $btn = $(this);
    const hint = getFavoriteHint($btn, isFavorite);
    const isToast = $btn.hasClass("contest-favorite-btn--toast");

    $btn.toggleClass("is-favorite", isFavorite);
    $btn.find(".contest-favorite-btn__icon").remove();

    const $icon = $(isFavorite ? FAVORITE_ICON_FILLED : FAVORITE_ICON_OUTLINE);
    const $hint = $btn.find(".contest-favorite-btn__hint");

    if ($hint.length) {
      $hint.before($icon);
      // Пока показывается toast — не затираем его текст hover-подсказкой.
      if (!isToast) {
        $hint.text(hint);
      }
    } else {
      $btn.prepend($icon);
    }
    $btn.attr("aria-pressed", isFavorite ? "true" : "false");
    $btn.attr("aria-label", hint);
  });
};

const toggleFavoritesFilterVisibility = (favoritesCount) => {
  const $filterItem = $(".js-favorites-filter-item");
  if (!$filterItem.length) {
    return;
  }

  if (favoritesCount > 0) {
    $filterItem.removeClass("hidden");
  } else {
    $filterItem.addClass("hidden");
    $filterItem.find('input[name="filter[favorites]"]').prop("checked", false);
  }
};

const getToastContainer = ($btn) => {
  const $social = $btn.closest(".contest-social");
  if ($social.length) {
    return $social;
  }

  const $cardImage = $btn.closest(".block-contests-all-card-image");
  if ($cardImage.length) {
    return $cardImage;
  }

  return $();
};

const buildToastMessage = (type, favoritesPageUrl) => {
  if (type === "added") {
    return `Конкурс добавлен в <a class="contest-favorite-toast__link" href="${favoritesPageUrl}">Избранное</a> в кабинете Участника`;
  }

  if (type === "removed") {
    return "Конкурс убран из Избранного";
  }

  return "";
};

/**
 * Один пузырь на кнопку: либо hover-hint, либо toast-сообщение.
 * Отдельный .contest-favorite-toast создаём только если у кнопки нет __hint.
 */
const showContestFavoriteToast = (type, favoritesPageUrl, $btn) => {
  const message = buildToastMessage(type, favoritesPageUrl);
  if (!message) {
    return;
  }

  const btnEl = $btn.get(0);
  const $hint = $btn.find(".contest-favorite-btn__hint");

  // Убираем любые старые toast-пузыри (в т.ч. от предыдущей логики).
  $(".contest-favorite-toast").remove();
  $(".contest-favorite-btn--toast").each(function () {
    if (this !== btnEl) {
      clearToastTimer(this);
      restoreHoverHint($(this));
    }
  });

  if ($hint.length) {
    clearToastTimer(btnEl);
    $btn.addClass("contest-favorite-btn--toast");
    $hint.html(message);

    const timerId = window.setTimeout(() => {
      toastTimers.delete(btnEl);
      restoreHoverHint($btn);
    }, TOAST_DURATION_MS);

    toastTimers.set(btnEl, timerId);
    return;
  }

  const $container = getToastContainer($btn);
  if (!$container.length) {
    return;
  }

  const $toast = $(`<div class="contest-favorite-toast">${message}</div>`);
  $container.append($toast);

  window.setTimeout(() => {
    $toast.fadeOut(200, () => {
      $toast.remove();
    });
  }, TOAST_DURATION_MS);
};

const removeFavoriteCard = (contestId) => {
  const $card = $(`.block-contests-all-card`).filter(function () {
    return $(this).find(`.js-contest-favorite[data-contest-id="${contestId}"]`).length > 0;
  });

  if ($card.length) {
    $card.fadeOut(200, function () {
      $(this).remove();
      if (!$(".block-contests-all-card").length) {
        $(".js-favorite-contests-empty").removeClass("hidden");
      }
    });
  }
};

export default function initContestFavorite() {
  const config = getConfig();

  $(document).on("click", ".js-contest-favorite", function (event) {
    event.preventDefault();
    event.stopPropagation();

    const $btn = $(this);
    const contestHash = $btn.data("contest-hash");
    const contestId = $btn.data("contest-id");

    if (!contestHash) {
      return;
    }

    $.ajax({
      type: "POST",
      url: `/contests/${contestHash}/favorite`,
      dataType: "json",
    })
      .done((response) => {
        if (response.status === "auth_required" && response.joinUrl) {
          window.location.href = response.joinUrl;
          return;
        }

        if (response.status !== "success") {
          return;
        }

        updateFavoriteButtons(contestId, response.isFavorite);
        toggleFavoritesFilterVisibility(response.favoritesCount);

        if (response.isFavorite) {
          showContestFavoriteToast("added", config.favoritesPageUrl, $btn);
        } else {
          showContestFavoriteToast("removed", config.favoritesPageUrl, $btn);
        }

        if (!response.isFavorite && $(".js-favorite-contests-page").length) {
          removeFavoriteCard(contestId);
        }
      });
  });
}
